<template>
  <div class="head">
    <div class="max-image">
      <img :src="companyInfo&&companyInfo.banner?'https://www.htsd.vip'+companyInfo.banner: require('../assets/images/ymxg1920x180_2.jpg')" alt />
    </div>
    <div class="head-select">
      <div class="head-selsct-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="网站首页" name="home"></el-tab-pane>
          <el-tab-pane label="商务合作" name="commonMessage"></el-tab-pane>
          <el-tab-pane label="联系我们" name="callMe"></el-tab-pane>
          <!-- <el-tab-pane label="充值中心" name="voucherCenter"></el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "headc",
  data() {
    return {
      input:'',
      activeName:'home'
    };
  },
  computed: {
    ...mapState(['companyInfo'])
  },
  methods: {
     handleClick(tab, event) {
      this.activeName = tab.name;
      if(this.$route.path == '/'+ tab.name) return 
      this.$router.push({ path: tab.name });
    },
  },

  created(){
    console.log(333)
  },
  watch:{
    '$route.path':function(){
      if(this.$route.path =='/home'||this.$route.path =='/'){
          this.activeName = 'home'
      }
      if(this.$route.path =='/newsNotice'){
          this.activeName = 'newsNotice'
      }
      if(this.$route.path =='/sportsVenue'){
          this.activeName = 'sportsVenue'
      }
      if(this.$route.path =='/sportsVenueInfo'){
          this.activeName = 'sportsVenue'
      }
      if(this.$route.path =='/commonMessage'){
          this.activeName = 'commonMessage'
      }
      if(this.$route.path =='/callMe'){
          this.activeName = 'callMe'
      }
      if(this.$route.path =='/newsDetails'){
          this.activeName = 'newsNotice'
      }
      if(this.$route.path =='/messageDetails'){
          this.activeName = 'commonMessage'
      }
      if(this.$route.path =='/voucherCenter'){
          this.activeName = 'voucherCenter'
      }
    }
  }
};
</script>

<style scoped lang='less'>
.head {
  width: 100%;
  .max-image {
    width: 100%;
    img {
      width: 100%;
      display: block;
    }
  }
  .head-select {
    margin: 0;
    height: 60px;
    width: 100%;
    // _
    // background:#9faeec;
    // _1
    // background:#53a9a5;
    // _3
    // background:#507085;
    // _2
    background:#97574c;

    
    .head-selsct-content {
      margin: 0 auto;
      width: 1198px;
      height: 100%;
      /deep/.el-tabs__item.is-active{
        // background-color: #abacc7;
        // background-color: #86a6a7;
        // background-color: #507085;
        background-color: #4c2d28;
      }
      // /deep/.el-tabs__nav ,.is-top{
      //   // transform: translateX(50%)!important
      // }
      /deep/.el-tabs__item{
        color: #fff;
        width: 152px;
        text-align: center;
        font-size: 18px;
        height: 60px;
        line-height: 60px;
        padding: 0;
      }
      /deep/.el-tabs__nav-wrap::after{
        height: 0px;
      }
      /deep/.el-tabs ,.el-tabs--top{
          height: 100%;
          .el-tabs__header, .is-top{
            margin: 0;
            .el-tabs__nav-scroll{
              line-height: 60px;
              height: 60px;
              color: #fff!important;
            }
          }
        }

      .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
        background:rgba(34,164,230,1);
      }
      .el-menu{
        background-color: #9faeec;
      }
      .head-selsct-content-left{
        display: inline-block;

      }
      .el-menu--horizontal>.el-menu-item{
        // margin-right: 100px;
        width: 152px;
        text-align: center;
        font-size: 18px;
        color: #fff;

      }
      .el-menu-item{
        padding: 0;
        height: 60px;
        line-height: 60px;
      }
      .el-menu.el-menu--horizontal{
        border: none;
      }
      .el-input{
        width:260px;
        height: 36px;
        vertical-align: top;
        margin-top:20px;
        // margin-left:190px;
        float: right;
        /deep/.el-input__inner{
        border-radius: 25px;
      }
      }
      /deep/.el-input__icon{
        height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headComponent.vue